module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("TABLE OF CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('p', {
    staticClass: "line"
  }, [_c('img', {
    attrs: {
      "alt": "inline",
      "src": "images/line4.jpg"
    }
  })])]), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/dedication",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preface"
    }
  }, [_c('i', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ack"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01"
    }
  }, [_c('b', [_vm._v("Section 1: A Life of Purpose Through Prosperity")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01"
    }
  }, [_c('span', {
    staticClass: "toc-lab"
  }, [_vm._v("Chapter 1")]), _vm._v(" Fulfilling Your Higher Purpose")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-lab"
  }, [_vm._v("Chapter 2")]), _vm._v(" Customer Service is Killing Your Business")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-lab"
  }, [_vm._v("Chapter 3")]), _vm._v(" The Separation of Church and Business Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Section 2: Transforming From Production to Purpose")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-lab"
  }, [_vm._v("Chapter 4")]), _vm._v(" Time to Find the True Love In Your Life!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-lab"
  }, [_vm._v("Chapter 5")]), _vm._v(" Building Your Kingdom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-lab"
  }, [_vm._v("Chapter 6")]), _vm._v(" Transforming Into a Provider")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-lab"
  }, [_vm._v("Chapter 7")]), _vm._v(" The Power of Wisdom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Section 3: Shortening Your Walk Through the Desert")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-lab"
  }, [_vm._v("Chapter 8")]), _vm._v(" Falling in Love With Your Product is Killing Your Business")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-lab"
  }, [_vm._v("Chapter 9")]), _vm._v(" Working the Jobsite is Killing Your Business")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-lab"
  }, [_vm._v("Chapter 10")]), _vm._v(" Giving Out Raises is Killing Your Business")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-lab"
  }, [_vm._v("Chapter 11")]), _vm._v(" The Call to Fulfilling Your Purpose in the World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm-top"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Endnotes")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0